import type { AppCurrency } from "./localePrefs";

export type PriceMap = Partial<Record<AppCurrency, number>>;

export type RegionPrice = number | PriceMap | null | undefined;

export function resolvePrice(
  price: RegionPrice,
  currency: AppCurrency,
): number {
  if (price == null) return 0;
  if (typeof price === "number") return price;
  if (typeof price === "object") {
    const amount = price[currency];
    return typeof amount === "number" ? amount : 0;
  }
  return 0;
}

export function hasRegionPrice(price: unknown): boolean {
  if (price == null) return false;
  if (typeof price === "number") return price > 0;
  if (typeof price === "object" && !Array.isArray(price)) {
    return Object.values(price as Record<string, unknown>).some(
      (value) => typeof value === "number" && value > 0,
    );
  }
  return false;
}
